module.exports = __webpack_public_path__ + "img/cvv-error.39b08d4a.svg";